import objectPath from "object-path";
import React from 'react';
import format from 'string-template';
import uniqid from 'uniqid';

/**
 * let Locale = require("./Constructor");
 * let language = "CN";
 * let locale = new Locale(language);
 * window.__ = locale.init();
 *
 * __("Your number is {number}", "number", { number:123 });
 *
 * // in your CN.json
 * {
 *   number: {
 *		"Your number is {number}": "你的号码是{number}。好吗？",
 *   }
 * }
 *
 *
 */

const DEFAULT_FIRST_LANGUAGE = 'EN';

const PRIMARY_SECOND_LANGUAGE = 'CN';

class LocaleConstructor {
  constructor(locale) {

		let languageInUrl = this.getParam('language')

		this.localeName = locale || languageInUrl || localStorage.getItem("language") || "EN";
		this.domain = "";
    this.domainData = {};
    this.localeData = {};
    this.domainIDs = {};
		this.debug = false;

    this.add = this.add.bind(this);
    this.getLocale = this.getLocale.bind(this);

    this.localeData = require("./translations/" + this.localeName);

    for (let rootDomain in this.localeData) {
      this.domainIDs[rootDomain] = uniqid();
    }
	}

  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

	init() {
		localStorage.setItem("language", this.localeName);
		return this.show.bind(this);
	}

  add(domain, id, mixin) {
    let domainId = this.domainIDs[domain];
    if (domainId && domainId !== id) {
      throw new Error(`Domain ${domain}[id=${id}] is already registered under id=${domainId}.`);
    }
    this.domainIDs[domain] = id;
    this.localeData[domain] = mixin;
  }

  getLocale() {
    return this.localeName || DEFAULT_FIRST_LANGUAGE;
  }

	show(str, domain, params) {
    let translated;

    if (typeof domain === 'object') {
      if (domain.id && domain.text) {
        // NEW IMPLEMENTATION
        // domain has text and id
        let texts = domain.text[str];

        if (texts && domain.code === this.localeName) {
          translated = texts;
        } else {
          translated = str;
        }

      } else {
        let texts = domain[str];
        if (typeof texts === 'object') {
          // incase of:
          // {
          //   "CN": ""
          // }
          translated = texts[this.localeName];
        } else if (typeof texts === 'string' && this.localeName === PRIMARY_SECOND_LANGUAGE) {
          // if there is a string and also the current locale is a primary second language (Chinese etc)
          translated = texts;
        } else {
          translated = str;
        }
      }
    } else {

      if (typeof domain !== "undefined") {
        if (domain != this.domain) {
         this.domain = domain;
         this.domainData = objectPath.get(this.localeData, this.domain);
        }
      } else {
        this.domainData = this.localeData;
        this.domain = "main";
      }

      if (this.domainData) {
        translated = this.domainData[str];
      }

    }

    return format(translated || str || "", params);
	}
}

export default LocaleConstructor



// WEBPACK FOOTER //
// ./src/locale/Constructor.js